import React from 'react';
import './styles.css';

interface StaticErrorProps {
  error: string;
}

export const StaticError: React.FC<StaticErrorProps> = ({ error }: StaticErrorProps) => {
  return (
    <div className="static-error-page" data-testid="static-error-page">
      <div className="header-wrapper">
        <header>
          <nav>
            <div className="logo-wrapper">
              <a href="/">
                <img src="/static/images/tenants/askporter/logo.svg" alt="logo" />
              </a>
            </div>
          </nav>
        </header>
      </div>
      <main>
        <section>
          <h1>Error</h1>
          <article>
            {error}
            <br />
            <a href="/">Return to homepage</a>
          </article>
        </section>
      </main>
    </div>
  );
};

export default StaticError;
